/**
 * Fréquence d'affichage côté client (web + même logique pour mobile).
 * Utilise sessionStorage / localStorage — pas de Redux persist.
 */

function storageKey(popupId, frequency) {
  return `baoubab_popup_${frequency}_${popupId}`;
}

export function canShowPopup(popup) {
  if (!popup?.id) return false;

  const frequency = popup.display_frequency || 'once_per_session';
  if (frequency === 'always') return true;

  const key = storageKey(popup.id, frequency);

  if (frequency === 'once_per_session') {
    return !sessionStorage.getItem(key);
  }

  if (frequency === 'once_per_day') {
    return localStorage.getItem(key) !== new Date().toDateString();
  }

  if (frequency === 'once_per_week') {
    const now = new Date();
    const weekId = `${now.getFullYear()}-W${Math.ceil(
      ((now - new Date(now.getFullYear(), 0, 1)) / 86400000 + 1) / 7
    )}`;
    return localStorage.getItem(key) !== weekId;
  }

  return true;
}

export function markPopupShown(popup) {
  if (!popup?.id) return;

  const frequency = popup.display_frequency || 'once_per_session';
  if (frequency === 'always') return;

  const key = storageKey(popup.id, frequency);

  if (frequency === 'once_per_session') {
    sessionStorage.setItem(key, '1');
    return;
  }

  if (frequency === 'once_per_day') {
    localStorage.setItem(key, new Date().toDateString());
    return;
  }

  if (frequency === 'once_per_week') {
    const now = new Date();
    const weekId = `${now.getFullYear()}-W${Math.ceil(
      ((now - new Date(now.getFullYear(), 0, 1)) / 86400000 + 1) / 7
    )}`;
    localStorage.setItem(key, weekId);
  }
}
